module.exports = __webpack_public_path__ + "media/images/product/f_h-8f1ae2c8470584dd48d16dd29505507b.png";